// extracted by mini-css-extract-plugin
export default {"frame":"IconCircleFrame_frame__I+laq","frame_label":"IconCircleFrame_frame_label__H+O7W","loading":"IconCircleFrame_loading__BeC85"};